export default "__VITE_ASSET__D5G4Xgqw__"